"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaginationButtonMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
/** @class PaginationButtonMixin */
/** @method */
var PaginationButtonMixin = (0, _styledToken.default)({
  radius: 'PaginationButton.radius',
  size: 'PaginationButton.size',
  padding: 'PaginationButton.padding'
}, function (_ref) {
  var radius = _ref.radius,
    size = _ref.size,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? 0 : _ref$padding;
  return (0, _styledComponents.css)(["border-radius:", ";height:", "px;width:", "px;display:flex;align-items:center;justify-content:center;padding:", "px;&,&:hover{text-decoration:none;}&[aria-pressed='true']:disabled{opacity:1;}", "{margin:0;}"], radius, size, size, padding, _Icon.StyledIcon);
});
exports.PaginationButtonMixin = PaginationButtonMixin;